<template>

	<div>
		<div class="nav-bar van-nav-bar van-hairline--bottom">
			<div class="van-nav-bar__content">
				<div class="van-nav-bar__left" @click="back()">
					<i class="van-icon van-icon-arrow-left" style="color: rgb(255, 255, 255);"></i>
				</div>
				<div class="van-nav-bar__title van-ellipsis">{{$t('recharge.recharge')}}</div>
			</div>
		</div>
		<div class="flex-xy-center">
			<div style="width: 100%;">
				
				<div class="payBtn mg-y-30 pd-xy-20 reset bg-linear-primary van-button--round" style="background: linear-gradient(30deg, #7d76ef, #d63f8c);" @click="onSubmit"> {{$t('recharge.Payment')}} </div>
				<div class="payBtn mg-y-30 pd-xy-20 reset bg-linear-primary van-button--round" style="background: linear-gradient(30deg, #7d76ef, #d63f8c);" @click="onSubmit"> {{$t('recharge.Bank')}} </div>
			</div>
		</div>
	</div>

</template>

<script>
	import Vue from "vue";
	import {
		Form
	} from "vant";
	import {
		Field
	} from "vant";
	import {
		RadioGroup,
		Radio
	} from "vant";
	Vue.use(Form).use(Field).use(RadioGroup).use(Radio);
	export default {
		data() {
			return {
				userInfo: {},
				balance: 0,
				pay_way: "Mexicopay",
				win_money: 0,
				money: "",
				personalreport: {},
			};
		},
		mounted() {
			this.balance = this.$route.params.balance;
		},
		methods: {
			back() {
				return window.history.back();
			},

			//拉起支付
			onSubmit() {
				// Please contact customer service to recharge!
				this.$toast(this.$t("recharge.money_err"));
			},

			getPersonalreport() {
				this.$http({
					method: "get",
					url: "user_get_personalreport",
				}).then((res) => {
					if (res.code === 200) {
						this.personalreport = res.data;
						this.win_money =
							this.personalreport.win_money - this.personalreport.play_money;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
		},
		created() {
			if (!localStorage.getItem("token")) {
				this.$router.push({
					path: "/Login"
				});
			} else {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						console.log(this.userInfo);
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
				// this.getPersonalreport();
			}
		},
	};
</script>

<style lang='less' scoped>
	@import "../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
	}

	.container .header {
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
	}

	.recharge {
		padding: 10px 30px;
	}

	.van-cell {
		line-height: 65px !important;
	}

	.van-button {
		height: 87px !important;
	}

	.van-button__text {
		color: #fff !important;
	}

	/deep/.van-radio__icon {
		font-size: 30px !important;
	}

	/deep/.van-radio__label {
		margin-left: 25px !important;
		font-size: 35px !important;
	}

	/deep/.van-radio {
		height: 65px !important;
	}

	.form-item {
		margin-top: 40px;
	}

	.form-item-title {
		font-size: 36px;
		font-weight: bold;
		color: #999;
		margin-bottom: 20px;
	}

	.recharge span {
		font-size: 4vw;
		color: #868686;
		font-weight: 500;
	}

	.container .header .info {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 20px;
		padding-top: 10px;
		margin: auto;
	}

	.container .header .info .title {
		font-size: 25px;
		color: #e5e5e5;
	}

	.container .header .info .value {
		margin: 10px auto;
		color: #fff;
		font-size: 50px;
		border-bottom: 1px solid #fff;
	}

	.container .header .info .tip {
		font-size: 30px;
		color: #e5e5e5;
	}

	.container .content {
		flex: 1;
		background: #f2f2f5;
	}

	.payBtn {
		text-align: center;
		width: 85%;
		margin: 0 4vw;
		margin: 8vw auto;
		padding: 2.667vw;
		color: #fff !important;
		background: linear-gradient(90deg, #f87171, #f87171);
	}
</style>